// @flow
import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';
import Home from 'models/Home';
import * as FavoriteActionTypes from 'action_types/FavoriteActionTypes';
import CancelableRequests from 'utils/CancelableRequests';
import { isNil as _isNil } from 'lodash';

class FavoriteActions {
  cancelableRequests = new CancelableRequests();

  saveFavorite(
    user_id: string,
    data: any,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${user_id}/favorites.json`,
      jsonData: data,
      success,
      error
    });
  }

  deleteFavorite(
    user_id: string,
    favorite_id: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.delete({
      path: `/users/${user_id}/favorites/${favorite_id}.json`,
      success,
      error
    });
  }

  getFavoritesByUsers(user_id: string = '') {
    return ApiClient.get({
      ...this.cancelableRequests.cancelableParams,
      path: `/users/${user_id}/favorites.json`,
      success: response => {
        Dispatcher.dispatch({
          type: FavoriteActionTypes.FAVORITE_BY_USER,
          home: response.favorites
            .filter(favorite => !_isNil(favorite.home))
            .map(favorite => new Home(favorite.home))
        });
      },
      error: error => {
        if (error.status === 404) {
          Dispatcher.dispatch({
            type: FavoriteActionTypes.FAVORITE_USER_ERROR,
            error: undefined
          });
        }
      }
    });
  }

  saveFavoritesAfterLogin(
    user_id: string,
    homes: Array<string>,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${user_id}/favorites.json`,
      jsonData: {
        favorite: {
          home_ids: homes,
          favorite_type: 'home'
        }
      },
      success,
      error
    });
  }

  cancelAllRequests() {
    this.cancelableRequests.cancelAllRequests();
  }
}

export default new FavoriteActions();
